import { error, warning, info } from './logger';

export { LogContextProvider, getWrapperWithLogContext } from './LogProvider';
export * from './hook';
export * from './logger';
export const logger = {
  info,
  warning,
  error,
};
